<template>
  <div class="map" ref="mapContainer">&nbsp;</div>
</template>
<script setup>

import { useScriptTag } from '@vueuse/core';

const props = defineProps({
  coords: String,
  id: String // fallback for dynamically added maps to content which is translated to <item id="..."></item
});

const mapContainer = ref(null);

const lat = parseFloat((props.coords ?? props.id).split(',')[0]);
const lng = parseFloat((props.coords ?? props.id).split(',')[1]);

if (process.client) {
  window.pinSymbol = (color) => {
    return {
      path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
      fillColor: color,
      fillOpacity: 1,
      strokeColor: '#000',
      strokeWeight: 2,
      scale: 1
    };
  }
}

const initMap = () => {

    var map1 = new google.maps.Map(mapContainer.value, {
      center: { lat: lat, lng: lng },
      scrollwheel: true,
      zoom: 17,
      disableDefaultUI: true
    });

    var marker1 = new google.maps.Marker({
      map: map1,
      icon: pinSymbol("#33cc59"),
      position: { lat: lat, lng: lng },
      title: 'Rigad.cz'
    });
  
}

if (process.client) {
  if (!window.googleMapsLoaded) {
    useScriptTag('https://maps.googleapis.com/maps/api/js?key=AIzaSyCtaQxut27XiSX3VrQV4HuZHJzkIozjgcw', (el) => {
      initMap();
      window.googleMapsLoaded = true;
    });
  }
  else {
    onMounted(() => {
    initMap();
    });
  }
}

</script>
<style lang="postcss">
.map {
  @apply w-full h-full;
}
</style>